export default __webpack_public_path__ + "static/media/project-added-to-profile.eb7002f2.svg";